import React from 'react';

const SkeletonTopBanner = () => {
    return (
        <div className="skeleton-top-banner-wrapper">
            <div className="container">
                <div className="top-banner br-2 skeleton-loading"></div>
            </div>
        </div>
    );
};

export default SkeletonTopBanner;
